const DEFAULT_API_ENDPOINT =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview"
    ? "https://api-internal.tokenterminal.dev"
    : "https://api-internal.tokenterminal.com"

export const API_ENDPOINT =
  process.env.NEXT_PUBLIC_API_ENDPOINT || DEFAULT_API_ENDPOINT
export const API_DEFAULT_TOKEN = process.env.NEXT_PUBLIC_API_DEFAULT_TOKEN || ""

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

export const BEEHIIV_API_TOKEN = process.env.BEEHIIV_API_TOKEN
export const BEEHIIV_PUBLICATION_ID = process.env.BEEHIIV_API_V2_PUBLICATION_ID
